import {
  GROUPING_CATEGORY_AREA,
  GROUPING_CATEGORY_EQUIPMENT,
  GROUPING_FILTER_AREA_FUNCTIONAL,
  GROUPING_FILTER_AREA_ROOM,
  GROUPING_FILTER_EQUIPMENT_DESCRIPTION,
  GROUPING_FILTER_EQUIPMENT_GROUP,
  GROUPING_FILTER_EQUIPMENT_TYPE,
  GROUPING_FILTER_TYPE,
  SET_GROUPING_CATEGORY,
  SET_GROUPING_FILTER,
  SET_GROUPING_FILTER_RELATIONS,
  SET_GROUPING_MODE
} from '../constants/actionTypes';

export const setGroupingMode = mode => {
  return {
    type: SET_GROUPING_MODE,
    mode
  };
};

export const setGroupingType = category => {
  return {
    type: SET_GROUPING_CATEGORY,
    category
  };
};

export const setGroupingFilter = filter => {
  return {
    type: SET_GROUPING_FILTER,
    filter
  };
};

export const setGroupingFilterRelations = payload => {
  return {
    type: SET_GROUPING_FILTER_RELATIONS,
    payload
  };
};

export const getGroupKey = groupFilter => {
  switch (groupFilter) {
    case GROUPING_CATEGORY_AREA:
      return 'equipment';
    case GROUPING_CATEGORY_EQUIPMENT:
      return 'area';
    case GROUPING_FILTER_EQUIPMENT_GROUP:
      return 'equipment_group';
    case GROUPING_FILTER_EQUIPMENT_TYPE:
      return 'equipment_type';
    case GROUPING_FILTER_TYPE:
      return 'type';
    case GROUPING_FILTER_EQUIPMENT_DESCRIPTION:
      return 'equipment_description';
    case GROUPING_FILTER_AREA_FUNCTIONAL:
      return 'area_functional';
    case GROUPING_FILTER_AREA_ROOM:
      return 'area_room';
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/actions/grouping.js